module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Christy_Black.2dfc54fe.webp";